<template>
	<div class="tools panel">
		<ul>
			<li v-for="(item,i) in dateData" :key="i" :class="{'active':item.act}" @click="selectDate(item)">{{item.name}}</li>
		</ul>
	</div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
	name: 'DatePicker',
	data() {
		return {

		}
	},
	computed: {
		...mapState('siteStas', ['dateData', 'datePickerData'])
	},
	methods: {
		...mapMutations('siteStas',['setDataPickerData']),
		...mapActions('siteStas',['getDaily', 'getRealtime', 'getSearchWord']),
		//时间选择
		selectDate(curDate) {
			let dateCode = curDate.code
			this.dateData.forEach(item => {
				item.act = false
			})
			curDate.act = true
			this[dateCode]()

		},
		today() {
			let oneDay = moment().format('YYYY-MM-DD')
			this.setDataPickerData({oneDay})
			this.getSearchWord()
			this.getRealtime()
		},
		yesterday() {
			let oneDay = moment().subtract(1,'days').format('YYYY-MM-DD')
			// let endDay = moment().format('YYYY-MM-DD')
			this.setDataPickerData({
				oneDay
			})
			this.getSearchWord()
			this.getRealtime()
		},
		week() {
			let startDay = moment().subtract(6,'days').format('YYYY-MM-DD')
			let endDay = moment().format('YYYY-MM-DD')
			this.setDataPickerData({
				startDay, endDay
			})
			this.getSearchWord()
			this.getDaily()
		},
		month() {
			let startDay = moment().subtract(29,'days').format('YYYY-MM-DD')
			let endDay = moment().format('YYYY-MM-DD')
			this.setDataPickerData({
				startDay, endDay
			})
			this.getSearchWord()
			this.getDaily()
		}
	}
}
</script>

<style lang="scss" scoped>
    .tools {
        height: 45px;
        padding: 0;
        margin-bottom: 76px;
        line-height: 20px;
        text-align: center;
        border-bottom: solid 1px #C6CDE6;
        ul {
            margin: 0;
            padding: 0;
        }

        li {
            float: left;
            width: 130px;
            height: 45px;
            cursor: pointer;
            line-height: 45px;
			list-style: none;
			border-bottom:3px solid transparent ;
            &.active {
				border-bottom-color: $colorA;
            }
        }
    }
</style>
